function IconBadge({ icon: Icon, tone = 'accent', size = 'md', className = '' }) {
  const tones = {
    accent: 'bg-accent-soft text-accent',
    inverse: 'bg-white/15 text-white',
    neutral: 'bg-ink/5 text-ink'
  };
  const sizes = {
    md: 'h-11 w-11 rounded-2xl',
    lg: 'h-14 w-14 rounded-[18px]'
  };
  const iconSize = size === 'lg' ? 28 : 22;

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center ${sizes[size]} ${tones[tone]} ${className}`}
      aria-hidden="true"
    >
      <Icon size={iconSize} weight="duotone" />
    </span>
  );
}

export default IconBadge;
